import * as React from "react";
import classNames from "classnames";
import Icon, { TIconNames } from "../icons/icon";

export interface IIconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
    iconId?: TIconNames;
    ariaLabel?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const IconButton: React.FC<IIconButtonProps> = props => {
    const baseClass = "icon-button";
    const componentClasses = classNames(baseClass, props.className);
    const iconWrapperClasses = `${baseClass}--icon-wrapper`;
    const iconClasses = `${baseClass}--icon`;
    const textClasses = `${baseClass}--text`;

    return (
        <button
            aria-label={props.ariaLabel}
            className={componentClasses}
            type={props.type || "button"}
            disabled={!!props.disabled}
            onClick={e => {
                if (props.onClick) {
                    props.onClick(e);
                }
            }}
        >
            {props.iconId && (
                <span className={iconWrapperClasses}>
                    <Icon iconId={props.iconId} className={iconClasses} />
                </span>
            )}
            {props.children ? <span className={textClasses}>{props.children}</span> : null}
        </button>
    );
};
export default IconButton;
